import type { ChartData, ChartOptions } from "chart.js";

export function capacityChartOption(): ChartOptions {
  return {
    animation: false,
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      title: {
        display: true,
        text: 'Installed Capacity',
        color: 'rgba(255,255,255,0.88)',
        font: { size: 12 },
        padding: { bottom: 4 },
      },
    },
    scales: {
      x: {
        stacked: true,
        grid: {
          offset: false,
          color: 'rgba(255,255,255,0.08)',
        },
      },
      y: {
        stacked: true,
        title: {
          display: true,
          text: 'Capacity (GW)',
          padding: 0,
          font: { size: 11 },
          color: 'rgba(255,255,255,0.65)',
        },
        grid: { color: 'rgba(255,255,255,0.08)' },
      },
    },
  };
}
interface ICapacityChartData {
  allInputData: any;
  sliderValues: any;
}
export function capacityChartData({
  allInputData,
  sliderValues
}: ICapacityChartData): ChartData {
  return {
    labels: ["Capacity"],
    datasets: generateDatasets({ allInputData, sliderValues })
  };
}

const generateDatasets = ({
  allInputData,
  sliderValues
}: ICapacityChartData) => {
  let result = [];
  let index = 0;

  for (const technology of allInputData.technologyData) {
    if (technology.name !== "Blackout") {
      result.push({
        label: technology.name,
        yAxesID: 'stackedCapY',
        borderWidth: 1,
        borderRadius: 3,
        order: 3,
        borderColor: technology.color,
        backgroundColor: technology.color,
        data: [sliderValues[index]]
      });
    }
    index++;
  }

  return result;
};
